import { Col, FormGroup, Row } from 'reactstrap';

export const SkeletonUpdateEmployee = () => {
	// Skeleton loading style
	const skeletonStyle: React.CSSProperties = {
		minHeight: '1.5em',
		width: '100%'
	};

	const skeletonCircleStyle: React.CSSProperties = {
		width: '100%',
		height: '200px',
		margin: '0 auto 1rem auto'
	};

	return (
		<>
			<Row>
				<Col sm={5} xl={4}>
					<FormGroup>
						<div
							className="skeletonCircleStyle"
							style={skeletonCircleStyle}></div>
					</FormGroup>
				</Col>
				<Col sm={7} xl={8}>
					<form>
						<Row>
							<Col xl={9} xxl={7}>
								<FormGroup>
									<div
										className="skeletonStyle"
										style={{
											...skeletonStyle,
											height: '3em',
											marginBottom: '1em'
										}}
									/>
								</FormGroup>
								<FormGroup>
									<div
										className="skeletonStyle"
										style={{
											...skeletonStyle,
											height: '3em',
											marginBottom: '1em'
										}}
									/>
								</FormGroup>
								<FormGroup>
									<div
										className="skeletonStyle"
										style={{
											...skeletonStyle,
											height: '10em',
											marginBottom: '1em'
										}}
									/>
								</FormGroup>
								<FormGroup>
									<div
										className="skeletonStyle"
										style={{
											...skeletonStyle,
											height: '3em',
											width: '6em',
											marginBottom: '1em'
										}}
									/>
								</FormGroup>
								<FormGroup>
									<div
										className="skeletonStyle"
										style={{
											...skeletonStyle,
											height: '3.5em',
											width: '12em'
										}}
									/>
								</FormGroup>
							</Col>
						</Row>
					</form>
				</Col>
			</Row>
		</>
	);
};
